const secrets = {
  apiKey: "AIzaSyDrhzDng5Mtg3Ui2JeHYOsVqGIoRVIcrJ4",
  messagingSenderId: "692530082330",
  appId: "1:692530082330:web:6192b4b2b9488be5ac57a3",
  measurementId: "G-M4MZZ47HSV",
};
export default secrets;
